import React,{ useRef } from 'react'
import { Box, Checkbox,  Button, IconButton } from '@mui/material';
import { deepCopy } from '../../../app/util';
import icons from './svgIcons';
import './RoomFilterMenu.scss';

const { checkedIcon, unCheckedIcon,indeterminateFilledIcon, checkedEmptyIcon, closeIcon, indeterminateIcon, checkedOutline, halfCheckedOutline,
    rightBottomResizeIcon, filterIcon, activeFilterIcon } = icons;


const RoomFilterMenu = (props) => {
    const {
        roomTypesGroupByClass,
        setRoomTypesGroupByClass,
        setSelectedRoomTypes,
        baseRoom,
        baseClass,
        app_state,
        ui_state
    } = props;
    const [open, setOpen] = React.useState(null);
    const [roomTypesGroupByClassState, setRoomTypesGroupByClassState] = React.useState(deepCopy(roomTypesGroupByClass));

    const popoverRef = useRef(null);

    const allRoomClasses = Object.keys(roomTypesGroupByClass);
    //combine all room types into a single array
    const allRoomTypes = Object.keys(roomTypesGroupByClassState).flatMap(cls => roomTypesGroupByClassState[cls].all || []);
    // combine all selected room types into a single array
    const allSelectedRoomTypes = Object.keys(roomTypesGroupByClassState).flatMap(cls => roomTypesGroupByClassState[cls].selected || []);

    const allRoomTypesGroupByClassSelected = Object.keys(roomTypesGroupByClass).flatMap(cls => roomTypesGroupByClass[cls].selected || []);
    const allRoomTypesGroupByClassSelectedString = allRoomTypesGroupByClassSelected.toString();
    const modified = useRef(false);
    

    
    const handleClick = (event) => {
        setOpen(() => {
            if(open){
                popoverRef.current.style = {};
                popoverRef.current.classList.remove('removeTransition');
                return false;
            }
            else{
                setTimeout(() => {
                    popoverRef.current.classList.add('removeTransition');
                }, 400)
                return true;
            }
        });
        modified.current = false
    };

    const popupClose = () => {
        popoverRef.current.style ={};
        popoverRef.current.classList.remove('removeTransition');
        setOpen(false);
    };


    const selectBaseRoom = ( state ) => {
        state[baseClass].selected.push(baseRoom);
        return state; 
    }
    const handleCloseBth = () =>{
        handleRoomTypeCheckbox('reset', '' , '') 
        popupClose();
    }

    const handleApply = () => {
        setRoomTypesGroupByClass(roomTypesGroupByClassState);
        setSelectedRoomTypes( () => {  
            const source = Object.keys(roomTypesGroupByClassState).flatMap(cls => roomTypesGroupByClassState[cls].all || []);
            let target = Object.keys(roomTypesGroupByClassState).flatMap(cls => roomTypesGroupByClassState[cls].selected || []);
            target.sort((a, b) => source.indexOf(a) - source.indexOf(b));
            return target;
        })
        popupClose();
    }

    const handleRoomTypeCheckbox = (type, roomClass, roomType) => {
        setRoomTypesGroupByClassState(prevState => {
            let newState = deepCopy(prevState);
            switch (type) {
                case 'class':
                    if(newState[roomClass].selected.length){
                        newState[roomClass].selected = [];
                    }
                    else{
                        newState[roomClass].selected = deepCopy(newState[roomClass].all);
                    }
                    break;
                case 'room':
                    if(newState[roomClass].selected.includes(roomType)){
                        //remove room type from selected
                        newState[roomClass].selected = newState[roomClass].selected.filter(item => item !== roomType);
                    }
                    else{
                        newState[roomClass].selected.push(roomType);
                    }
                    break;    
                case 'reset':
                    newState = deepCopy(roomTypesGroupByClass)
                    break;
            }
            const selectedCount = Object.values(newState).reduce((count, roomType) => {
                return count + roomType.selected.length;
            }, 0); 
            if (selectedCount === 0) {
                newState = selectBaseRoom(newState);
            }
            const newStateSelected = Object.keys(newState).flatMap(cls => newState[cls].selected || []);
            const newStateSelectedString = newStateSelected.toString();
            modified.current = allRoomTypesGroupByClassSelectedString !== newStateSelectedString;
            return newState;
        })
        
    }   


    return (
        <Box className={`room-filters ${open ? 'open' : ''}`} id={(window.createUniqueElementId('plr_filter'))}>
            <button className={`room-filters-button ${allSelectedRoomTypes.length===allRoomTypes.length ? '' : 'active'}`} onClick={handleClick}>
                {allSelectedRoomTypes.length===allRoomTypes.length ? filterIcon : activeFilterIcon}
                Room Category
                {allSelectedRoomTypes.length===allRoomTypes.length ? '' : <span className='room-filters-count'>{allSelectedRoomTypes.length}</span>}
            </button>
            
            <div className={`room-filters-popover `} ref={popoverRef}  > 
                <IconButton aria-label="close" size="small" className='room-filters-close-button' onClick={handleCloseBth}>
                    {closeIcon}
                </IconButton>
                <span className='br-resize-icon'>{rightBottomResizeIcon}</span>
                <Box className="room-filters-body">
                    {allRoomClasses.map((roomClass, index) => (
                        <>
                            {tabLabel(roomClass, roomTypesGroupByClassState[roomClass], handleRoomTypeCheckbox)}
                            <Box key={index}  className="checkbox-list">
                                {roomTypesGroupByClassState[roomClass].all.map((roomType, index) =>{ 
                                    const isChecked = roomTypesGroupByClassState[roomClass].selected.includes(roomType);
                                    return (
                                        <label key={index} className='checkbox-label'>
                                            <Checkbox
                                                key={index}
                                                checked={isChecked}
                                                onChange={() => handleRoomTypeCheckbox('room', roomClass, roomType)}
                                                //indeterminate={isSomeClassSelected}
                                                icon={unCheckedIcon}
                                                checkedIcon={checkedOutline}
                                                //indeterminateIcon={indeterminateIcon}
                                                sx={{ p: "4px" }}
                                            />
                                            {roomType}
                                        </label>
                                    )
                                })}
                            </Box>
                        </>  
                    ))}
                </Box>

                <Box className="room-filters-footer" sx={{ display: "flex", justifyContent: "space-between", isolation: "isolate", boxShadow: "0 4px 0.75rem rgba(12, 14, 28, 0.3)", borderBottomLeftRadius: '4px', borderBottomRightRadius: '4px' }}>
                    <Button className='filter-button secondary' disabled={!modified.current} onClick={() => { handleRoomTypeCheckbox('reset', '' , '') }} variant="outlined" sx={{ mr: 1 }} size="small">Reset to Default</Button>
                    <Button className='filter-button primary' variant="outlined" onClick={()=>handleApply()} size="small" disabled={!modified.current} >Apply</Button>
                </Box>
            </div>
        </Box>
    )
}

const tabLabel = (label, roomTypesGroupByClassParams, handleRoomTypeCheckbox) => {
    let isChecked = roomTypesGroupByClassParams.selected.length === roomTypesGroupByClassParams.all.length;
    let isSomeClassSelected = roomTypesGroupByClassParams.selected.length > 0 && roomTypesGroupByClassParams.selected.length < roomTypesGroupByClassParams.all.length;
    return (
        <div className='title-label'>
            <label className='checkbox-label' >
                <Checkbox
                    checked={isChecked}
                    indeterminate={isSomeClassSelected}
                    icon={unCheckedIcon}
                    checkedIcon={checkedIcon}
                    indeterminateIcon={indeterminateIcon}
                    sx={{ p: "4px" }}
                    onClick={() => handleRoomTypeCheckbox('class', label, '')}
                />
                <strong>{label}</strong>
                <span><span className='selected-count'>{roomTypesGroupByClassParams.selected.length}/{roomTypesGroupByClassParams.all.length}</span></span>
            </label>
            
        </div>
    )
}

export default RoomFilterMenu